// import instance from "utils/interceptor";
import instance, { request } from "utils/interceptor";
import instance1 from "utils/interceptor1";
export const createClient = async (data, method = "get") => {
  let url = ``;
  // let requestData = method !== "get" ?  data : {}
  if (method == "put") {
    url = `/api/v2/clients/${data.id}`;
  } else if (method == "post") {
    url = `/api/v1/clients`;
  } else {
    url = `/api/v2/clients/?size=100`;
  }

  try {
    const res = await instance1[method](url, data);
    return res;
  } catch (error) {
    throw error;
  }
};

// /api/v1/management/roles/
export const ClientsRoles = async () => {
  try {
    let res = await instance1.get(`/api/v1/management/roles/`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getClient = async (data, method = "get") => {
  try {
    const res = await instance[method](`/api/v2/clients/?id=${data.id}&size=1`);
    return res;
  } catch (error) {
    throw error;
  }
};

// export const updateClient = async (data, method = "put") => {
//   try {
//     const res = await instance[method]("/api/v2/clients", data);
//     return res;
//   } catch (error) {
//     throw error;
//   }
// };
// export const deleteClient = async (data, method = "delete" ) => {
//   try {
//     const res = await instance[method]("/api/v2/clients", data);
//     return res;
//   } catch (error) {
//     throw error;
//   }
// };

export const deleteClient = async (data) => {
  try {
    // const res = await instance[method]("/api/v2/clients", data);
    const res = await instance.delete(`/api/v2/clients/${data.id}`, false);
    return res;
  } catch (error) {
    throw error;
  }
};

export const KillSwitch = async (url, headers, method = "post") => {
  try {
    const res = await request(url, method, headers, false);
    return res;
  } catch (error) {
    throw error;
  }
};

export const clientIsActive = async (data) => {
  try {
    const res = await instance1.post(
      `/api/v1/premium-strategies/portfolio/update-mappings`,
      data
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const clientIsDiscard = async (data) => {
  try {
    const res = await instance.post(`/api/v2/clients/discard-client`, data);
    return res;
  } catch (error) {
    throw error;
  }
};
// api/v2/clients/?is_active=0&is_discard=1
// api/v2/clients/?is_active=0
// api/v2/clients/?is_discard=1
// api/v2/clients/?is_active=1

export const activeee = async (data) => {
  try {
    const res = await instance.get(`api/v2/clients/?is_active=1`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getClientsList = async (page = 0, size, name = "", endpoint) => {
  var url;
  if (endpoint === "active") {
    url = `/api/v2/clients/?page=${page}&size=${size}&is_active=1&is_discard=0${
      name ? `&name=${name}` : ""
    }`;
  } else if (endpoint === "pause") {
    url = `/api/v2/clients/?page=${page}&size=${size}&is_active=0&is_discard=0${
      name ? `&name=${name}` : ""
    }`;
  } else if (endpoint === "discard") {
    url = `/api/v2/clients/?page=${page}&size=${size}&is_discard=1${
      name ? `&name=${name}` : ""
    }`;
  } else {
    url = `/api/v2/clients/?page=${page}&size=${size}${
      name ? `&name=${name}` : ""
    }`;
  }
  try {
    const res = await instance.get(
      // `/api/v2/clients/?page=${page}&size=${size}${name ? `&name=${name}` : ""}`
      url
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export const getClientNewlist = async (page, size, condition, text,text2) => {
  try {
    text2=text2 || ""
    
    const boolean = condition === "active" ? "true" : false;
    let res = await instance1.get(
      `/api/v1/premium-strategies/client/order-approval-client?page_number=${page}&page_size=${size}&is_active=${boolean}&client=${text}&fund_manager=${text2}`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const getClientNewlistNew = async (page, size, condition, text) => {
  try {
    const boolean = condition === "active" ? "true" : false;
    let res = await instance1.get(
      `/api/v1/premium-strategies/client/order-approval-client?page_number=${page}&page_size=${size}&is_active=${boolean}&client=${text}`
    );
    return res;
  } catch (error) {
    throw error;
  }
};


export const getClientlistBysearch = async (data) => {
  try {
    let res = await instance1.post(`/api/v1/clients/filter`, data);
    return res;
  } catch (error) {
    throw error;
  }
};
export const getDashboardActiveClientlist = async (size) => {
  try {
    let res = await instance1.get(
      `/api/v1/premium-strategies/client/order-approval-client?page=${0}&size=${size}&is_active=true`
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const getClientsListPL = async (page,size,data) => {
  try {
    let res = await instance1.post(`/api/v1/reports/analysis/pnl?page_number=${page}&page_size=${size}`,data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getAccestokenPl = async () => {
  try {
    let res = await instance.get(`/api/v2/clients/clientpl-update`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getIndivisualClientsListPL = async (email) => {
  try {
    let res = await instance.get(
      `/api/v2/clients/clientpl-list?email=${email}`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const searchIndivisualClientsList = async (name, page) => {
  try {
    let res = await instance.get(`/api/v2/clients/clientpl-list?name=${name}`);
    return res;
  } catch (error) {
    throw error;
  }
};
export const checkAccessToken = async () => {
  try {
    let res = await instance.post("/api/v2/clients/update-started-fund");
    return res;
  } catch (error) {
    throw error;
  }
};
export const SubscriptionCheck = async () => {
  try {
    let res = await instance.post("/api/v2/clients/check-subscription");
    return res;
  } catch (error) {
    throw error;
  }
};

export const randomUrlCall = async () => {
  // const { email, secret_key } = data;
  try {
    const res = await instance.post(
      // `/api/v2/orders/avg/?email=${email}&secret_key=${secret_key}`
      `/api/v2/orders/avg`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const todaysAvg = async () => {
  // const { email, secret_key } = data;

  try {
    const res = await instance.post(
      // `/api/v2/orders/today-avg/?email=${email}&secret_key=${secret_key}`
      `/api/v2/orders/today-avg`
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// get client list
export const getUserList = async (page = 0, size = 50) => {
  try {
    const res = await instance.get(`/api/v2/users?page=${page}&size=${size}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const userProfile = async (data = "", method = "get") => {
  try {
    const res = await instance[method](`/api/v2/users/profile`, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const downloadExcelSheet = async () => {
  try {
    const res = await instance.get(`api/v2/orders/download`);
    return res;
  } catch (error) {}
};

export const clientlistReport = async (text) => {
  try {
    const res = await instance1.get(`/api/v1/premium-strategies/client/order-approval-clients?page_number=1&page_size=50&client=${text}`);
    return res;
  } catch (error) {}
};

// get client strategy list
export const getClientStrategyList = async (id) => {
  try {
    const res = await instance1.post(
      `/api/v1/premium-strategies/portfolio/client-mappings-find/`,
      id
    );
    return res;
  } catch (error) {
    throw error;
  }
};
